export enum ActivityZoneType {
  Heartrate = 'heartrate',
  Power = 'power',
}
